module.exports = __webpack_public_path__ + "images/igglo-logo-white.b12a2b5ebb5ba4b9cfe4c36820324f68.svg";